import { List } from 'immutable';
import { comparableCompanyConstants } from '../constants';

export function comparable_companies(state = {}, action) {
  switch (action.type) {
    case comparableCompanyConstants.COMPARABLE_COMPANY_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case comparableCompanyConstants.COMPARABLE_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response.companyResponseList),
        hasValues: action.response.hasValues,
        date: action.response.date,
        listLoading: false
      };
    case comparableCompanyConstants.COMPARABLE_COMPANY_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        hasValues: false,
        date: null,
        listError: action.error
      };
    case comparableCompanyConstants.COMPARABLE_COMPANY_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case comparableCompanyConstants.COMPARABLE_COMPANY_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case comparableCompanyConstants.COMPARABLE_COMPANY_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case comparableCompanyConstants.COMPARABLE_COMPANY_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case comparableCompanyConstants.COMPARABLE_COMPANY_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const comparableCompanyIndex = state.items.findIndex(val => val.id == action.response.id);

      if (comparableCompanyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(comparableCompanyIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case comparableCompanyConstants.COMPARABLE_COMPANY_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case comparableCompanyConstants.COMPARABLE_COMPANY_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case comparableCompanyConstants.COMPARABLE_COMPANY_DELETE_SUCCESS: {
      const { comparableCompanyId } = action;

      if (!state.items) {
        return state;
      }

      const comparableCompanyIndex = state.items.findIndex(val => val.id == comparableCompanyId);

      if (comparableCompanyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(comparableCompanyIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case comparableCompanyConstants.COMPARABLE_COMPANY_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case comparableCompanyConstants.COMPARABLE_COMPANY_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
